export enum EStaticPageName {
  FAQ = 'faq',
  TERMS = 'terms',
  PRIVACY = 'privacy',
  COMMISSION = 'commission',
  HELP = 'help',
  STATIC_PAGE_1 = 'static_page_1',
  STATIC_PAGE_2 = 'static_page_2',
  STATIC_PAGE_3 = 'static_page_3',
  STATIC_PAGE_4 = 'static_page_4',
  STATIC_PAGE_5 = 'static_page_5',
}
